<template>
    <div class="epidemicForm">
        <div class="title">
            <div class="selectBox">
                <div class="dateBox" @click="handleClickDate">
                    <img src="../../../../assets/images/epidemicForm/time.png" class="icon">
                    <span>{{ selectedDate }}</span>
                </div>
            </div>
            <span class="title-word">大数据分析-疫情管控</span>
        </div>
        <!-- 日期选择 -->
        <div :class="ifShowDateBox ? 'dateOptionBox show' : 'dateOptionBox'">
            <!-- 清空选项 -->
            <div class="clear">
                <span @click="handleClickClearDate">清除已选项</span>    
            </div>
            <div class="item" v-for="(item,i) in dateList" :key="i">
                <div class="text">请选择{{ item.title }}</div>
                <div class="list">
                    <div 
                        :class="selectedDateList.find(fitem => fitem == `${i}$${ci}`) ? 'list-item select' : 'list-item'" 
                        v-for="(citem,ci) in item.coptions" 
                        :key="ci"
                        @click="handleSelectDate(i,ci)">{{ citem.num }}{{ item.unit }}</div>
                </div>
            </div>
        </div>
        <div class="main">
            <div class="left">
                <Area1 class="area1" :provinceShortName="provinceName" :date="selectedDate"></Area1>
                <Area2 class="area2" :date="selectedDate"></Area2>
                <Area3 class="area3" :date="selectedDate"></Area3>
                <Area4 class="area4" :provinceShortName="provinceName" :date="selectedDate"></Area4>
            </div>
            <div class="middle">
                <Area5 class="area5" :date="selectedDate"></Area5>
                <Area6 class="area6" :date="selectedDate"></Area6>
                <Area7 class="area7" :date="selectedDate"></Area7>
            </div>
            <div class="right">
                <Area8 class="area8" :date="selectedDate"></Area8>
                <Area9 class="area9" :date="selectedDate"></Area9>
                <Area10 class="area10" :date="selectedDate"></Area10>
                <Area11 class="area11" :date="selectedDate"></Area11>
            </div>
        </div>
    </div>
</template>
<script>
import Area1 from './Area1';
import Area2 from './Area2';
import Area3 from './Area3';
import Area4 from './Area4';
import Area5 from './Area5';
import Area6 from './Area6';
import Area7 from './Area7';
import Area8 from './Area8';
import Area9 from './Area9';
import Area10 from './Area10';
import Area11 from './Area11';
export default {
    components: { 
        Area1,
        Area2,
        Area3,
        Area4,
        Area5,
        Area6,
        Area7,
        Area8,
        Area9,
        Area10,
        Area11
    },
    data(){
        return {
            provinceName: '',
            ifShowDateBox: false,
            dateList: [
                {
                    title: '年份',
                    unit: '年',
                    coptions: [
                        {
                            num: 2020
                        }
                    ]
                },
                {
                    title: '月份',
                    unit: '月',
                    coptions: [
                        {
                            num: '01'
                        },
                        {
                            num: '02'
                        },
                        {
                            num: '03'
                        },
                        {
                            num: '04'
                        },
                        {
                            num: '05'
                        },
                        {
                            num: '06'
                        },
                        {
                            num: '07'
                        },
                        {
                            num: '08'
                        },
                        {
                            num: '09'
                        },
                        {
                            num: '10'
                        },
                        {
                            num: '11'
                        },
                        {
                            num: '12'
                        },
                    ]
                },
                // {
                //     title: '日期',
                //     unit: '日',
                //     coptions: [
                //     ]
                // }
            ],
            selectedDateList: [],
            ifComputed: true,
            selectedDate: '日期选择'
        }
    },
    methods: {
        // 获取省份简称
        async getProvinceShort(){
            let res = await this.$get(this.urlobj.getProviceShort,{
                communityId:this.$route.query.communityId || this.$store.state.streetorcommunityid
            })
            this.provinceName = res.newPrimaryKeys.shortName;
        },
        // 处理点击时间选择
        handleClickDate(){
            this.ifShowDateBox = !this.ifShowDateBox;
        },
        // 获取当前月所含日期
        // getDateNums(year,month){ 
        //     this.dateList[2].coptions = [];
        //     let d = new Date(year,month,0).getDate();
        //     for(let n = 1; n <=d; n++ ){
        //         let obj = {
        //             num: n < 10 ? `0${ n }` : n
        //         }
        //         this.dateList[2].coptions.push(obj)
        //     }
        // },
        // 选中日期
        handleSelectDate(i,ci){
            this.selectedDateList = this.selectedDateList.filter(item => item.split('$')[0] !== i + '');
            this.selectedDateList.push(`${i}$${ci}`)
            this.$nextTick();
            this.ifComputed = !this.ifComputed;
            if(this.selectedDateList.find(item => item.split('$')[0] == '0') && this.selectedDateList.find(item => item.split('$')[0] == '1')){
                let year = 2020;
                let monthIndex = Number(this.selectedDateList.find(item => item.split('$')[0] == '1').split('$')[1]);
                // this.getDateNums(year,Number(this.dateList[1].coptions[monthIndex].num));
            }
        },
        // 处理清空选择日期
        handleClickClearDate(){
            this.selectedDateList = [];
        }
    },
    watch: {
        selectedDateList: {
            deep: true,
            handler: function(newVal){
                if(newVal.length != 0){
                    this.selectedDate = '';
                    let list = JSON.parse(JSON.stringify(newVal))
                    list.sort((a,b) => Number(a.split('$')[0]) - Number(b.split('$')[0]))
                    list.forEach(item => {
                        let [ i,ci ] = [ item.split('$')[0],item.split('$')[1] ]
                        this.selectedDate += this.dateList[i].coptions[ci] ? this.dateList[i].coptions[ci].num : '';
                    })
                }else {
                    this.selectedDate = '日期选择';
                }
            }
        }
    },
    created(){
        this.getProvinceShort();
        // this.getDateNums(2020,2);
    }
}
</script>
<style lang="less" scoped>
.epidemicForm{
    line-height: 1;
    width: 100%;
    height: 100%;
    background-image: url('../../../../assets/images/epidemicForm/background.jpg');
    box-sizing: border-box;
    padding: 0 20px 20px;
    .title {
        height: 85px;
        line-height: 85px;
        position: relative;
        text-align: center;
        .selectBox{
            position: absolute;
            left: 0;
            top: 0;
            height: 85px;
            display: flex;
            align-items: center;
            color: #fff;
            .dateBox{
                height: 30px;
                padding: 0 8px;
                border: 1px solid #008ff2;
                font-size: 14px;
                line-height: 28px;
                display: flex;
                align-items: center;
                background: #041235;
                box-shadow: inset 0 0 13px rgba(0,168,255,.7);
                cursor: pointer;
                .icon {
                    width: 28px;
                    height: 14px;
                }
            }
        }
        .title-word {
            color: #fefefe;
            font-size: 24px;
        }
    }
    .main {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: calc(100% - 85px);
    }
    .left,
    .right {
        width: 610px;
        height: 100%;
        display: flex;
        flex-flow: column;
        justify-content: space-between;
    }
    .middle {
        width: calc(100% - 1260px);
        height: 100%;
        display: flex;
        flex-flow: column;
        justify-content: space-between;
    }
    .area1,
    .area5,
    .area8 {
        width: 100%;
        height: 120px;
        background: rgba(22,30,49,0.8);
        border-radius: 4px;
    }
    .area2,
    .area3,
    .area4,
    .area7,
    .area9,
    .area10,
    .area11 {
        width: 100%;
        height: calc((100% - 180px)/3);
        background: rgba(22,30,49,0.8);
        border-radius: 4px;
    }
    .area6{
        width: 100%;
        height: calc((100% - 160px)*2/3);
        background: rgba(22,30,49,0.8);
        border-radius: 4px;
    }
    .dateOptionBox {
        height: calc(100% - 85px);
        width: 390px;
        background: rgba(0,0,1,.9);
        box-shadow: inset 0 0 40px rgba(34,140,251,.77);
        padding: 28px 0 28px 20px;
        box-sizing: border-box;
        position: fixed;
        top: 85px;
        left: -100%;
        z-index: 999;
        transition: all 0.3s;
        .clear {    
            height: 30px;
            padding: 0 16px;
            font-size: 13px;
            line-height: 30px;
            cursor: pointer;
            text-align: end;
            span{
                background: rgba(0,0,1,.9);
                box-shadow: inset 0 0 10px rgba(34,140,251,.77);
                border: 1px solid #008ff2;
                color: #fff;
                padding: 5px;
            }
        }
        .item {
            .text{
                font-size: 14px;
                height: 34px;
                line-height: 34px;
                color: #989898;
                margin-bottom: 5px;
            }
            .list{
                display: flex;
                flex-wrap: wrap;
                .list-item{
                    height: 28px;
                    border: 1px solid #0d6cc8;
                    width: 100px;
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                    text-align: center;
                    color: #0d6cc8;
                    font-size: 14px;
                    line-height: 26px;
                    margin-bottom: 20px;
                    margin-right: 20px;
                    cursor: pointer;
                }
                .list-item.select {
                    background: #0d6cc8;
                    color: #fff;
                }
            }
        }
    }
    .dateOptionBox.show{
        left: 0;
    }

}
</style>